import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import RequireAuth from './components/vx/Auth/RequireAuth.jsx';

// New VectraX design-system pages
const Landing = lazy(() => import('./pages/vx/Landing.jsx'));
const Signals = lazy(() => import('./pages/vx/Signals.jsx'));
const Watchlist = lazy(() => import('./pages/vx/Watchlist.jsx'));
const Strategies = lazy(() => import('./pages/vx/Strategies.jsx'));
const Portfolio = lazy(() => import('./pages/vx/Portfolio.jsx'));
const Research = lazy(() => import('./pages/vx/Research.jsx'));
const Login = lazy(() => import('./pages/vx/Login.jsx'));
const Subscribe = lazy(() => import('./pages/vx/Subscribe.jsx'));
const Account = lazy(() => import('./pages/vx/Account.jsx'));

// Retained legal pages
const Terms = lazy(() => import('./pages/Terms'));
const Privacy = lazy(() => import('./pages/Privacy'));

function App() {
  return (
    <Suspense fallback={null}>
      <Routes>
        {/* Browsable routes. The app is explorable without login (server enforces data
            entitlements + premium features are RequirePlan-gated); only personal/billing
            pages require a session. */}
        <Route path="/" element={<Landing />} />
        <Route path="/research" element={<Research />} />
        <Route path="/login" element={<Login />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/signals" element={<Signals />} />
        <Route path="/watchlist" element={<Watchlist />} />
        <Route path="/strategies" element={<Strategies />} />
        <Route path="/portfolio" element={<Portfolio />} />

        {/* Auth-gated: billing / personal data — signed-out users → /login?next= */}
        <Route path="/account" element={<RequireAuth><Account /></RequireAuth>} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />

        {/* Redirects from retired routes */}
        <Route path="/fundamental-signals" element={<Navigate to="/signals" replace />} />
        <Route path="/multi-strategy-signals" element={<Navigate to="/signals" replace />} />
        <Route path="/swing" element={<Navigate to="/strategies" replace />} />
        <Route path="/intraday" element={<Navigate to="/strategies" replace />} />
        <Route path="/ml-trading" element={<Navigate to="/strategies" replace />} />
        <Route path="/blog" element={<Navigate to="/research" replace />} />
        <Route path="/blog/:slug" element={<Navigate to="/research" replace />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}

export default App;
